module.exports = __webpack_public_path__ + "static/media/lyftLogoNoBg.ba5e0705.png";